import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';

export const GuideType = createEnum('ANSWER_GUIDE', 'TRANSACTION_GUIDE');

const GuidePerformance = createModel({
  modelName: 'GuidePerformance',
  properties: {
    id: prop(String).isRequired,
    name: prop(String).isRequired,
    type: prop().oneOf(...Object.values(GuideType)).isRequired,
    collectionId: prop(String).isRequired,
    collectionName: prop(String).isRequired,
    references: prop(Number).isRequired,
    handoffs: prop(Number).isRequired,
    resolved: prop(Number).isRequired,
    resolutionRate: prop(Number).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default GuidePerformance;
